import React, { useContext } from 'react';
import _merge from 'lodash/merge';
import { IconBadgeContext } from 'components/Badge';

import { getContext } from 'common';
import Icon, { IconProps } from 'components/Icon';
import Styled, { DEFAULT_BADGE_ICON_SIZE, EMERGENCY_BADGE_SIZE } from './styles';

const ICON_STYLE = {
  height: '100%',
  width: '100%',
};

export interface BadgeIconProps extends IconProps {
  /** If false, the icon will not be reversed when in RTL mode.  */
  isRTL?: boolean;
  /**
   * @ignore
   * To customize the style of wrapper.
   * */
  style?: React.CSSProperties;
}

/** Any props will be provided to the Icon component. */
const BadgeIcon = React.forwardRef<HTMLElement, BadgeIconProps>((props: BadgeIconProps, ref) => getContext(({ RTL }) => {
  const {
    style: propStyle,
    isRTL,
    ...otherProps
  } = props;
  const iconBadgeContext = useContext(IconBadgeContext);
  const resolvedStyle = _merge({}, ICON_STYLE, propStyle);
  return (
    <Styled.BadgeIconWrapper $isFault={iconBadgeContext.status === 'fault'} $isElevated={iconBadgeContext.isElevated}>
      <Icon
        ref={ref}
        RTL={RTL && isRTL}
        style={resolvedStyle}
        size={iconBadgeContext.variant === 'default' ? DEFAULT_BADGE_ICON_SIZE : EMERGENCY_BADGE_SIZE}
        role={undefined}
        aria-label=""
        {...otherProps}
      />
    </Styled.BadgeIconWrapper>
  );
}));

BadgeIcon.defaultProps = {
  isRTL: true,
  style: {}
};

BadgeIcon.displayName = 'BadgeIcon';

export default BadgeIcon;